module.exports = __webpack_public_path__ + "media/images/woman-unsuccess-e68c07b788eef5a7c51c059095a08cad.png";